var exports = {
  "vK": "banner__S4ORKn",
  "ZI": "attached__Z2g4k0",
  "Qs": "content__6JfHZa",
  "DD": "title__C2JT3E",
  "Kk": "icon__SHlgFu",
  "VQ": "offlineIcon__OF711P",
  "rf": "body__kLr4Y_",
  "XI": "action__DUCAKi",
};

module.exports = exports;
